import { render, staticRenderFns } from "./ProductCreationWorkshopButton.vue?vue&type=template&id=7eecfb58&scoped=true&"
import script from "./ProductCreationWorkshopButton.vue?vue&type=script&lang=js&"
export * from "./ProductCreationWorkshopButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eecfb58",
  null
  
)

export default component.exports